import { Badge, Box, Stack, Typography } from '@mui/material'

import * as OrderTexts from '../../../../../../../intl'
import { DetectedTimeProps } from '../../typings'
import { parseSecondToText } from '../../utils'

import { preview } from '@/components/form/preview'
import { form } from '../../../../formState'

export function DetectedTime(props: DetectedTimeProps) {
  const {
    trackingData: { autoTimeInSec, autoTimeOutSec },
  } = props

  const autoTimeInDisabled: boolean = autoTimeInSec === -1
  const autoTimeOutDisabled: boolean = autoTimeOutSec === -1

  const autoTimeInText = parseSecondToText(autoTimeInSec)
  const autoTimeOutText = parseSecondToText(autoTimeOutSec)

  return (
    <form.Fieldset direction="row" spacing={2} justifyContent="space-between">
      <Box width="100%">
        <preview.Field
          label={
            <Stack direction="row" alignItems="center" spacing={2} ml={1}>
              <Badge
                variant="standard"
                badgeContent="3"
                sx={{
                  '& .MuiBadge-badge': {
                    backgroundColor: autoTimeInDisabled ? 'action.disabled' : 'info.main',
                    color: autoTimeInDisabled ? 'action.disabled' : 'default',
                  },
                }}
              />
              <Typography variant="caption">{OrderTexts.getDetectedTimeInLabel()}</Typography>
            </Stack>
          }
        >
          {autoTimeInText}
        </preview.Field>
      </Box>
      <Box width="100%">
        <preview.Field
          label={
            <Stack direction="row" alignItems="center" spacing={2} ml={1}>
              <Badge
                variant="standard"
                badgeContent="4"
                sx={{
                  '& .MuiBadge-badge': {
                    backgroundColor: autoTimeOutDisabled ? 'action.disabled' : 'info.main',
                    color: autoTimeOutDisabled ? 'action.disabled' : 'default',
                  },
                }}
              />
              <Typography variant="caption">{OrderTexts.getDetectedTimeOutLabel()}</Typography>
            </Stack>
          }
        >
          {autoTimeOutText}
        </preview.Field>
      </Box>
    </form.Fieldset>
  )
}
